<script lang="ts">
    import queryString from "query-string";
    import { navigate } from "svelte-navigator";
    import { Col, Container, Row } from "sveltestrap";
    import { appManager } from "../AppManagerStore";
    import AngleStart from "../svg/shapes/AngleStart.svelte";
    import { _ } from "svelte-i18n";

    let start = async () => {
        setTimeout(() => {
            navigate(`${$appManager.PublicUrl}`, { replace: true });
        }, 4000);
    };
</script>

{#await start()}
    <div />
{/await}
<section>
    <Container class="d-flex flex-column">
        <Row class="align-items-center justify-content-center gx-0 min-vh-100">
            <Col>
                <h1 class="mb-0 fw-bold">
                    {$_("newsletter.thanks.title")} 👍
                </h1>

                <p class="mb-6 text-muted">
                    {$_("newsletter.thanks.subtitle")}
                </p>

                <p class="mb-6 text-muted">
                    {$_("newsletter.thanks.redirect.part1")}
                    <a href={$appManager.PublicUrl}
                        >{$_("newsletter.thanks.redirect.here")}</a>
                    {$_("newsletter.thanks.redirect.part2")}
                </p>
            </Col>

            <div
                class="col-lg-7 offset-lg-1 align-self-stretch d-none d-lg-block">
                <div
                    class="h-100 w-cover bg-cover"
                    style="background-image: url(/img/covers/cover-belgium-at-night.jpg);" />

                <div class="shape shape-start shape-fluid-y text-white">
                    <AngleStart />
                </div>
            </div>
        </Row>
    </Container>
</section>
